export { default } from './ModalContent';

